export default {
    reasonOfReferences: 'reason Of References',
    reasonOfReferencesTitle: 'Title',
    reasonOfReferencesStatus: 'status',
    editReasonOfReferences: 'Edit Reason Of References',
    addReasonOfReferences: 'New Reason Of References',
    fileTypeOrUnit: 'fileTypeOrUnit',


    infertility: 'infertility',
    gynecology: 'gynecology',
    obstetric: 'obstetric',
    glands: 'glands',
    genetics: 'genetics',
    nourish: 'nourish',
    urology: 'urology',
    legal: 'legal',
    lab: 'lab',







}